module.exports = __webpack_public_path__ + "static/media/wave.a3ade6ed.png";